export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Recherchez votre adresse de livraison',
      },
      placeholder: "Entrez une adresse pour trouver l'emplacement le plus proche",
    },
  },
  toasts: {
    failed_to_load_stores: 'Impossible de charger les établissements, veuillez actualiser la page',
  },
  errors: {
    no_delivery_companies: 'Livraison non disponible pour cette adresse',
    delivery_not_available: 'Malheureusement, nous ne proposons pas de livraison pour le moment',
    location_unavailable:
      "Impossible d'accéder à votre position, veuillez autoriser la localisation ou saisir l'adresse manuellement",
    location_lookup_failed: 'Impossible de localiser votre adresse, veuillez réessayer',
    address_suggestions_unavailable: "Impossible de charger les suggestions d'adresse.",
  },
  buttons: {
    use_current_location: 'Utiliser ma position actuelle',
    locating: 'Localisation en cours…',
    retry: 'Réessayer',
  },
};
